import { extendObservable } from 'mobx'
import querystring from 'querystring'
import { projectManagementApi, teamApi } from '@atheneum/api'

class ProjectManagementStore {
  constructor (staticData) {
    this.staticData = staticData
    extendObservable(this, {
      loading: false,
      page: 1,
      count: 0,
      comments: [],
      currentProject: null,
      extra: ['', '', ''],
      expandedRecruiters: null,
      editExtraField: null,
      _actions: [],
      comment: '',
      teams: [],
      actions: [
        { id: null, name: 'None', dropdownName: 'All', color: 'transparent' }
      ],
      projects: [],
      query: {
        sortBy: 'created_at',
        priorityId: null,
        sortOrder: 'desc',
        teamId: null,
        projectId: null,
        action: null,
        projectStatusId: 1
      }
    })
  }

  saveActions = actions => {
    return projectManagementApi.updateActions(actions).then(() => this.setActions(actions))
  }

  init = async (userId, projectId) => {
    this.userId = userId
    const teams = await teamApi.getActiveTeams()
    this.teams.replace([{ id: null, name: 'Only my projects' }, ...teams])
    if (projectId) {
      this.query.projectId = projectId
    } else {
      try {
        this.query = JSON.parse(
          Object.keys(querystring.parse(window.location.hash))[0].replace(
            '#',
            ''
          )
        )
      } catch (err) {
        // console.log('could not parse', err)
      }
    }
    await this.getAll()
    if (projectId) {
      this.currentProject = this.projects[0]
    }
  }

  formatRow = r => {
    return {
      ...r,
      userIsHandler: Boolean(r.handlers.find(i => i.id === this.userId)),
      country: r.countryId ? this.staticData.names.countries[r.countryId] : '-',
      time: r.timezoneId ? this.getTime(r.timezoneId) : '-',
      segments: null
    }
  }

  loadComments = async project => {
    this.comments = await projectManagementApi.getComments(project.id)
    this.currentProject = project
  }

  addComment = async () => {
    if (!this.comment) return
    await projectManagementApi.postComment(this.currentProject.id, this.comment)
    const { projects } = await projectManagementApi.getAll({ projectId: this.currentProject.id })
    this.currentProject.comment = projects[0].comment
    this.comment = ''
    await this.loadComments(this.currentProject)
  }

  expandProject = async project => {
    if (project.segments) {
      project.segments = null
    } else {
      const segments = await projectManagementApi.getSegments(project.id)
      project.segments = segments
    }
  }

  getTime = timezoneId => {
    const timezone = this.staticData.timezones.find(
      ({ id }) => id === timezoneId
    )
    return timezone ? timezone.name : timezoneId
  }

  getAll = async () => {
    this.loading = true
    const { projects, actions, count } = await projectManagementApi.getAll(this.query)
    this.projects.replace(projects.map(this.formatRow))
    this.setActions(actions)
    this.count = count
    this.loading = false
    return this.projects
  }

  setActions = actions => {
    this._actions = actions
    this.actions.replace([
      { id: null, name: 'None', dropdownName: 'All', color: 'transparent' },
      ...actions
    ])
  }

  updateAction = (project, actionId, extra1, extra2, extra3) => {
    return projectManagementApi.updateAction({
      actionId,
      projectId: project.id,
      extra1,
      extra2,
      extra3
    }).then(() => (project.actionId = actionId))
  }

  updatePriority = (project, priorityId) => {
    return projectManagementApi.updateAction({ priorityId, projectId: project.id }).then(
      () => (project.priorityId = priorityId)
    )
  }

  search = (newQuery = {}, page = 1) => {
    // console.log('searching')
    this.query = {
      ...this.query,
      ...newQuery,
      page
    }
    window.location.hash = JSON.stringify(this.query)
    return this.getAll()
  }
}

export default ProjectManagementStore
